import { capitalize, classnames } from '@aibees/shared/utils';
import { Typography } from '@mui/material';
import { memo } from 'react';
import * as Styled from './styles';
import * as SX from './sx';
import type { TableCellTypographyProps as Props } from './types';

export const TableCellTypography = memo(
  ({
    className,
    item,
    variant = 'body3',
    fontWeight = 500,
    color = 'grey.700',
    hasCapitalize = false,
    ...props
  }: Props) => {
    if (!item)
      return (
        <Typography variant="body3" fontWeight={500} color="grey.400">
          N/A
        </Typography>
      );

    return (
      <Styled.Wrapper
        className={classnames('TableCellTypography', className)}
        sx={SX.root}
        children={hasCapitalize ? capitalize(String(item)) : String(item)}
        variant={variant}
        fontWeight={fontWeight}
        color={color}
        {...props}
      />
    );
  }
);

TableCellTypography.displayName = 'TableCellTypography';
